module.exports = __webpack_public_path__ + "static/media/911_m&m_white.42a0f97d.png";